import dynamic from 'next/dynamic';

import { getLazyHydrateTools } from '@/core/lazyHydrate/lazyHydrateTool';
import { Skeleton } from '@/core/tamagoshi/Skeleton/Skeleton';
import { type GuideCardProps } from '@/digitalAdvice/GuideCard/GuideCard';

import styles from './GuideCard.module.scss';

const { dynamicOptions, makeLazyHydrated } =
  getLazyHydrateTools<GuideCardProps>({
    id: 'digitalAdvice.GuideCard',
    on: 'visible',
    placeholder: <Skeleton className={styles.skeleton} />,
  });

const DynamicGuideCard = dynamic<GuideCardProps>(
  async () => (await import('@/digitalAdvice/GuideCard/GuideCard')).GuideCard,
  { ...dynamicOptions },
);

export const GuideCard = makeLazyHydrated(DynamicGuideCard);
